import { render, staticRenderFns } from "./BackTopButton.vue?vue&type=template&id=f4a98c80&scoped=true"
import script from "./BackTopButton.vue?vue&type=script&lang=js"
export * from "./BackTopButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a98c80",
  null
  
)

export default component.exports